const enumRoles = {
  aa: 'aa',
  信息录入: '信息录入',
  信息复核: '信息复核',
  申请结算: '申请结算',
  结算查看: '结算查看',
  结算审核: '结算审核',
  结算导出: '结算导出',
  申请报销: '申请报销',
  报销查看: '报销查看',
  报销审核: '报销审核',
  报销导出: '报销导出',
  加发养老金查看: '加发养老金查看',
  加发养老金审核: '加发养老金审核',
  储备转征收审核: '储备转征收审核',
  储备转征收查看: '储备转征收查看',
  预到龄查询: '预到龄查询',

  补发: '补发',
  停发: '停发',
  暂停: '暂停',
  追回: '追回',
  字典维护: '字典维护',
  账号管理: '账号管理',
  查看操作记录: '查看操作记录'
}
export default enumRoles



// WEBPACK FOOTER //
// ./src/utils/enumRoles.js